import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KeyValuePair, PartnerState, Partner } from '@fitscovery/partner/data-access';
import { Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { Select } from '@ngxs/store';
import { TranslateService } from '@ngx-translate/core';

export enum PageRoutePath {
  Events,
  Workouts,
  Programs,
  Payment,
  Community,
  Booking,
  Memberships,
  Schedules
}

@Injectable()
export class PageTitleService {
    @Select(PartnerState.partner) partnerState$: Observable<Partner>;
    pageTitles: KeyValuePair[];
    pageTitle: string;
    private url: string;
    private paymentRoutePath: string;
    partnerName: string;

    constructor(
      private router: Router,
      private titleService: Title,
      private translateService: TranslateService
    ) {
        this.partnerState$
            .subscribe((partner: Partner) => {
                this.partnerName = partner?.name!;
            });
    }

    private getPageTitles(): KeyValuePair[] {
        const array: KeyValuePair[] = [{
            key: PageRoutePath[PageRoutePath.Events],
            value: 'toolbars.liveEventsMenuOption'
        }, {
            key: PageRoutePath[PageRoutePath.Workouts],
            value: 'pages.workoutsTitle'
        }, {
            key: PageRoutePath[PageRoutePath.Programs],
            value: 'pages.workoutProgramTitle'
        }, {
            key: PageRoutePath[PageRoutePath.Payment],
            value: 'pages.paymentsPageTitle'
        }, {
            key: PageRoutePath[PageRoutePath.Memberships],
            value: 'pages.membershipsPageTitle'
        }, {
            key: PageRoutePath[PageRoutePath.Community],
            value: 'pages.communityTitle'
        }, {
            key: PageRoutePath[PageRoutePath.Booking],
            value: 'pages.bookSessionTitle'
        }, {
            key: PageRoutePath[PageRoutePath.Schedules],
            value: 'pages.schedulesPageTitle'
        }];

        return array;
    }

    setPageTitle(): string {
        this.url = this.router.url;
        this.pageTitles = this.getPageTitles();
        this.paymentRoutePath = PageRoutePath[PageRoutePath.Payment];
        this.pageTitles.forEach(pageTitle => {
            if (this.url.includes(pageTitle.key.toString().toLowerCase()) && !(this.url.includes(this.paymentRoutePath.toString().toLowerCase()))) {
                this.pageTitle = pageTitle.value;
            }
        });

        if (this.pageTitle === undefined) {
            this.pageTitle = this.pageTitles[PageRoutePath.Payment].value;
        }
        setTimeout(() => {
          this.titleService.setTitle(this.partnerName + ' - ' + this.getTranslation(this.pageTitle));
        });
        return this.pageTitle;
    }

    getTranslation(key: string) {
      const keys = key.split('.');
      const parentKey = keys[0];
      const childKey = keys[1];
      const currentLang = this.translateService.currentLang;
      const translations = this.translateService.translations;
      return translations[currentLang] 
        ? translations[currentLang][parentKey][childKey] : '';
    }

    

}
